module.exports = __webpack_public_path__ + "img/Grade.04b669b7.png";